import { render } from "./2022-10-28-Garbage.md?vue&type=template&id=1e6799a3"
const script = {}
script.render = render

export default script